module.exports = __webpack_public_path__ + "assets/images/editor-logo-6f885a1543496ebc23a21b7fea82b255.png";